import { AbstractRestService } from '../../../core/services/AbstractRestService';
import { Observable } from 'rxjs';

export abstract class AbstractArchiveService<T> extends AbstractRestService<T> {

  public toggleArchive(id: number, archive: boolean): Observable<void> {
    return this.apiService.patch(`${ this.basePath }/${ id }/archive?archive=${ archive }`);
  }

  public getAllArchived(): Observable<T[]> {
    return this.apiService.get(`${ this.basePath }/all?archive=true`);
  }
}
